"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var simplerestclients_1 = require("simplerestclients");
var localeMapper_1 = require("../localeMapper");
var LocalizationApiProvider = (function () {
    function LocalizationApiProvider(filePrefix, filePostfix) {
        var _this = this;
        this.getFilename = function (locale) {
            return _this.filePrefix + _this.localeMapper(locale) + _this.filePostfix;
        };
        this.localeMapper = localeMapper_1.mapLocale;
        this.restClient = new simplerestclients_1.GenericRestClient('');
        this.filePrefix = filePrefix;
        this.filePostfix = filePostfix;
    }
    LocalizationApiProvider.prototype.setLocaleMapper = function (mapper) {
        this.localeMapper = mapper;
        return this;
    };
    LocalizationApiProvider.prototype.setNamespace = function (namespace) {
        this.namespace = namespace;
        return this;
    };
    LocalizationApiProvider.prototype.getStringTable = function (locale) {
        return this.restClient
            .performApiGetDetailed(this.getFilename(locale))
            .then(function (result) { return result.body; });
    };
    LocalizationApiProvider.prototype.getNamespace = function () {
        return this.namespace;
    };
    return LocalizationApiProvider;
}());
exports.LocalizationApiProvider = LocalizationApiProvider;
